type RawHealthCheck = {
  key?: unknown;
  label?: unknown;
  status?: unknown;
  message?: unknown;
  meta?: unknown;
};

type RawHealth = {
  status?: unknown;
  summary?: unknown;
  checks?: unknown;
  issue_count?: unknown;
  healthy_count?: unknown;
};

export type SystemHealthStatus = 'healthy' | 'warning' | 'critical';

export interface NormalizedHealthCheck {
  key: string;
  label: string;
  status: SystemHealthStatus;
  message: string;
  meta: string;
}

export interface NormalizedSystemHealth {
  status: SystemHealthStatus;
  summary: string;
  checks: NormalizedHealthCheck[];
  issues: NormalizedHealthCheck[];
  issueCount: number;
  healthyCount: number;
}

const toTrimmedString = (value: unknown): string => {
  return typeof value === 'string' ? value.trim() : '';
};

const normalizeStatus = (value: unknown): SystemHealthStatus => {
  return value === 'critical' || value === 'warning' || value === 'healthy'
    ? value
    : 'warning';
};

const normalizeCheck = (item: RawHealthCheck, index: number): NormalizedHealthCheck => {
  const label = toTrimmedString(item?.label) || `Check ${index + 1}`;

  return {
    key: toTrimmedString(item?.key) || `check-${index + 1}`,
    label,
    status: normalizeStatus(item?.status),
    message: toTrimmedString(item?.message) || 'Status belum tersedia.',
    meta: toTrimmedString(item?.meta),
  };
};

export const normalizeSystemHealth = (
  raw?: RawHealth | null,
): NormalizedSystemHealth => {
  const input: RawHealth = raw ?? {};
  const rawChecks = Array.isArray(input.checks) ? input.checks : [];
  const checks = rawChecks.length > 0
    ? rawChecks.map((item, index) => normalizeCheck((item ?? {}) as RawHealthCheck, index))
    : [];

  const issues = checks.filter((check) => check.status !== 'healthy');
  const issueCount = typeof input.issue_count === 'number' ? input.issue_count : issues.length;
  const healthyCount = typeof input.healthy_count === 'number'
    ? input.healthy_count
    : checks.length - issues.length;

  return {
    status: normalizeStatus(input.status),
    summary: toTrimmedString(input.summary) || 'Status kesehatan sistem belum tersedia.',
    checks,
    issues,
    issueCount,
    healthyCount,
  };
};
